import styles from "./index.module.less";
import { Iconsvg } from "@wk/components-react16";
const Header = () => {
  return (
    <div className={styles["header-view"]}>
      <div className="text">关于Wolters Kluwer</div>
      <Iconsvg name="chevron-down" size={14}></Iconsvg>
    </div>
  );
};
export default Header;
